<template>
    <DashboardHeader />

    <DashboardStatsSummary />
    <DashboardActions />

    <section class="container-fluid content-type-37 side-by-side" v-if="(!analyticsLoaded && analyticsLoading) || (hasAccountStats && hasTraffic && hasDeviceType)">
        <div class="container">
            <div class="row">
                <DashboardTraffic :loading="analyticsLoading" v-if="!analyticsLoaded || hasTraffic" />
                <DashboardDeviceType :loading="analyticsLoading" v-if="!analyticsLoaded || hasDeviceType" />
            </div>
        </div>
    </section>

    <section class="container-fluid content-type-37 side-by-side" v-if="(!analyticsLoaded && analyticsLoading) || (hasAccountStats && hasPages && (hasSource || hasMedium))">
        <div class="container">
            <div class="row">
                <DashboardPages :loading="analyticsLoading" v-if="!analyticsLoaded || hasPages" />
                <DashboardSourceMedium :loading="analyticsLoading" v-if="!analyticsLoaded || hasSource || hasMedium" />
            </div>
        </div>
    </section>

    <DashboardLabels />

    <section class="container-fluid content-type-37 side-by-side" v-if="showTagsOwners">
        <div class="container">
            <div class="row">
                <DashboardTags ref="tags" @update-visibility="updateVisibility" />
                <DashboardOwners ref="owners" @update-visibility="updateVisibility" />
            </div>
        </div>
    </section>
</template>

<script>
    import { mapState, mapActions } from 'pinia';
    import { useAccountStore } from '@/stores/account';
    import DashboardHeader from '@/components/accountDashboard/DashboardHeader';
    import DashboardStatsSummary from '@/components/accountDashboard/DashboardStatsSummary'
    import DashboardLabels from '@/components/accountDashboard/DashboardLabels';
    import DashboardTags from '@/components/accountDashboard/DashboardTags';
    import DashboardOwners from '@/components/accountDashboard/DashboardOwners';
    import DashboardActions from '@/components/accountDashboard/DashboardActions';
    import DashboardPages from '@/components/accountDashboard/DashboardPages';
    import DashboardSourceMedium from '@/components/accountDashboard/DashboardSourceMedium';
    import DashboardDeviceType from '@/components/accountDashboard/DashboardDeviceType';
    import DashboardTraffic from '@/components/accountDashboard/DashboardTraffic';

    export default {
        name: 'DashboardManager',
        components: {
            DashboardHeader,
            DashboardStatsSummary,
            DashboardLabels,
            DashboardTags,
            DashboardOwners,
            DashboardActions,
            DashboardPages,
            DashboardSourceMedium,
            DashboardDeviceType,
            DashboardTraffic
        },
        computed: {
            ...mapState(useAccountStore, ['hasAccountStats', 'accountStats', 'stats']),
            hasPages() {
                return this.accountStats?.page_url && typeof(this.accountStats.page_url) === 'object' && Object.keys(this.accountStats.page_url).length > 0;
            },
            hasSource() {
                return this.accountStats?.source && typeof(this.accountStats.source) === 'object' && Object.keys(this.accountStats.source).length > 0;
            },
            hasMedium() {
                return this.accountStats?.medium && typeof(this.accountStats.medium) === 'object' && Object.keys(this.accountStats.medium).length > 0;
            },
            hasDeviceType() {
                return this.accountStats?.device_type && typeof(this.accountStats.device_type) === 'object' && Object.keys(this.accountStats.device_type).length > 0;
            },
            hasTraffic() {
                return this.accountStats?.matched && typeof(this.accountStats.matched) === 'object' && Object.keys(this.accountStats.matched).length > 0;
            }
        },
        data() {
            return {
                showTagsOwners: true,
                analyticsLoaded: false,
                analyticsLoading: false
            }
        },
        methods: {
            ...mapActions(useAccountStore, ['getAccountStats']),
            updateVisibility() {
                const tags = !this.$refs.tags || this.$refs.tags.hide;
                const owners = !this.$refs.owners || this.$refs.owners.hide;
                const hide = tags && owners;
                this.showTagsOwners = !hide;
            },
            async getStats() {
                this.analyticsLoading = true;
                await this.getAccountStats();
                this.analyticsLoading = false;
                this.analyticsLoaded = true;
            }
        },
        mounted() {
            this.getStats();
        }
    };
</script>
